module.exports = __webpack_public_path__ + "img/comfort.592de7a7.png";